// extracted by mini-css-extract-plugin
module.exports = {"container":"Statistics_container__YESM9","wrapper":"Statistics_wrapper__249nF","blocks-wrapper":"Statistics_blocks-wrapper__153u9"};